module.exports = __webpack_public_path__ + "static/media/payer-upload.e6f9d844.svg";